import Image from "next/image";
import Link from "next/link";
import React, { useState } from "react";
import Logo from "../../../../public/logo.svg";
import { BiGlobe, BiMenu, BiSearch, BiX } from "react-icons/bi";
import { Drawer, styled } from "@mui/material";
import MenuItems from "../MenuItem";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { FaAngleRight } from "react-icons/fa";
import SearchBox from "../desktop/Search";
import GoogleTranslate from "@/layout/GoogleTranslate";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { CountryCategory } from "@/lib/http";
import { IProductsByCountryCategory } from "@/lib/interface";
import CountryList from "../desktop/CountryList";
import GetQuote from "@/app/GetQuote";

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  padding: "0px 0px !important",
  margin: "0px 0px !important",
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<FaAngleRight style={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  padding: "0px 0px !important",
  border: "0px",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  // borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

const ToolBar = ({
  drawerOpen,
  setDrawerOpen,
}: {
  drawerOpen: boolean;
  setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const [searchProducts, setSearch] = useState(false);
  const [country, setCountry] = useState(false);
  let Icon = drawerOpen ? BiX : BiMenu;
  let SearchIcon = searchProducts ? BiX : BiSearch;

  return (
    <>
      <div className="bg-primary-main flex justify-center xl:hidden ">
        <GoogleTranslate />
      </div>
      <div className="p-3 sticky  drop-shadow-lg  z-40 w-full h-auto rounded-b-md bg-white left-0 top-0 flex justify-between items-center xl:hidden">
        <Link href="/">
          <Image
            src={Logo}
            alt="logo"
            width={150}
            height={65}
            loading="lazy"
            fetchPriority="high"
          />
        </Link>
        <div className="flex items-center gap-5">
          {searchProducts ? <SearchBox close={() => setSearch(false)} /> : null}

          {country && <CountryList close={() => setCountry(false)} />}
          {!drawerOpen ? (
            <BiGlobe
              className="w-6 h-6 text-orange-600 cursor-pointer"
              onClick={() => setCountry(!country)}
            />
          ) : null}

          <SearchIcon
            className="w-6 h-6 text-primary-main"
            onClick={() => setSearch(true)}
          />
          <Icon
            className="w-6 h-6 text-secondary-dark"
            onClick={() => setDrawerOpen(!drawerOpen)}
          />
        </div>
      </div>
    </>
  );
};

const MobileHeader = ({
  categoryData,
}: {
  categoryData: IProductsByCountryCategory | null;
}) => {
  const { countrySlug } = useSelector((state: any) => state.app);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [expanded, setExpanded] = useState("");

  const handleDrawerClose = () => {
    setDrawerOpen(false);
    setExpanded("");
  };
  const handleSubmenu =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : "");
    };

  const drawer = (
    <div className="rounded-b-md overflow-hidden w-full  z-40 ">
      <ToolBar drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />

      <ul className="flex flex-col   p-4 w-full ">
        {MenuItems.map((m) => {
          if (m.children)
            return (
              <li key={m.id} className="w-full">
                <Accordion
                  expanded={expanded === m.name}
                  onChange={handleSubmenu(m.name)}
                  sx={{ padding: 0, marging: 0 }}
                >
                  <AccordionSummary
                    aria-controls="panel1d-content"
                    id="panel1d-header"
                    sx={{ padding: 0, marging: 0 }}
                  >
                    <p
                      className={`text-md ${
                        expanded === m.name ? "pt-4 px-4 " : "p-4 border-b "
                      } text-secondary-dark font-bold hover:text-primary-main transition w-full block`}
                    >
                      {m.name}
                    </p>
                  </AccordionSummary>
                  <AccordionDetails>
                    <ul className="flex flex-col w-full border-t">
                      {m.products &&
                      Array.isArray(categoryData?.Categories) &&
                      categoryData.Categories.length > 0
                        ? categoryData.Categories.map((c) => (
                            <li
                              key={c?.CategoryID ?? c?.Slug}
                              className="w-full"
                            >
                              <Link
                                onClick={handleDrawerClose}
                                href={`/category/${
                                  c?.CategoryDetails?.Slug || c?.Slug
                                }${
                                  categoryData?.CountrySlug &&
                                  categoryData.CountrySlug !== "india"
                                    ? "/" + categoryData.CountrySlug
                                    : ""
                                }`}
                                className="text-sm py-4 text-secondary-dark font-bold hover:text-primary-main transition border-b w-full block"
                              >
                                {c?.Title || c?.CategoryName}
                              </Link>
                            </li>
                          ))
                        : Array.isArray(m.children) && m.children.length > 0
                        ? m.children.map((c) => (
                            <li key={c.id} className="w-full">
                              <Link
                                onClick={handleDrawerClose}
                                href={c.href ?? "/error"}
                                className="text-sm py-4 text-secondary-dark font-bold hover:text-primary-main transition border-b w-full block"
                              >
                                {c.name}
                              </Link>
                            </li>
                          ))
                        : null}
                    </ul>
                  </AccordionDetails>
                </Accordion>
              </li>
            );

          return (
            <li key={m.id} className="w-full">
              <Link
                href={m.href ?? "/error"}
                onClick={handleDrawerClose}
                className="text-md p-4 text-secondary-dark font-bold hover:text-primary-main transition border-b w-full block"
              >
                {m.name}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );

  return (
    <>
      <ToolBar drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
      <Drawer
        open={drawerOpen}
        onClose={handleDrawerClose}
        anchor="top"
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: "block" },
          "& .MuiDrawer-paper": { boxSizing: "border-box" },
        }}
      >
        {drawer}
      </Drawer>

      <button
        type="submit"
        onClick={() => setIsModalOpen(true)}
        className="block xl:hidden fixed z-30 group overflow-y-hidden py-1 px-4 border -right-12 rotate-90  font-semibold rounded-full items-center top-96 before:absolute before:bottom-0 before:left-0 before:bg-orange-main before:translate-y-0 hover:before:translate-y-12 before:transition-all before:w-full before:h-full before:rounded-full"
      >
        <p className="relative flex items-center group-hover:text-orange-main text-white">
          Get a Quote
        </p>
      </button>
      {isModalOpen && (
        <div
          className="fixed top-1/2 left-1/2 z-30 -translate-x-1/2 transform bg-primary-main -translate-y-1/2 flex items-center justify-end"
          onClick={() => setIsModalOpen(false)}
        >
          <div
            className="bg-modalFormColor p-6 rounded shadow-lg w-86 relative transition-transform ease-in duration-300 transform scale-100"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setIsModalOpen(false)}
              className="absolute top-6 text-2xl right-5 text-white"
            >
              &times;
            </button>
            <GetQuote setIsModalOpen={setIsModalOpen} />
          </div>
        </div>
      )}
    </>
  );
};

export default MobileHeader;
